import React from 'react';
import { WidgetPreviewDescription, WidgetPreviewImageFallback, WidgetPreviewInfo, WidgetPreviewName, WidgetPreviewType, WidgetPreviewWrapper } from './styled';
export const WidgetPreview = ({ title, type, description, previewImage }) => (React.createElement(WidgetPreviewWrapper, null,
    previewImage || React.createElement(WidgetPreviewImageFallback, null),
    React.createElement(WidgetPreviewInfo, null,
        React.createElement(WidgetPreviewName, null, title),
        React.createElement(WidgetPreviewType, null, type),
        React.createElement(WidgetPreviewDescription, null, description))));
